export default "https://statics.cloudfastin.top/static/v1.27.38.2/store/images/T12pdtXaldXXXXXXXX-2-2.png?9a2f0df755bb64fcbfc6f3880438caa7";